import { ErrorHandler as BaseErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AuthService, User } from '@auth0/auth0-angular';
import { Subscription } from 'rxjs';

@Injectable()
export class ErrorHandler implements BaseErrorHandler {
  user?: User;
  private readonly sentryErrorHandler = Sentry.createErrorHandler({
    showDialog: false,
  });
  private subscription: Subscription;

  constructor(private readonly auth: AuthService) {
    this.subscription = this.auth.user$.subscribe(async user => {
      this.user = user;
    });
  }

  handleError(error: any): void {
    if (this.user && this.user.email && this.user.email.endsWith('optitax.ca')) {
      // Prevent Sentry from logging errors for Optitax users
      return;
    }

    this.sentryErrorHandler.handleError(error);
  }
}
